import { render, staticRenderFns } from "./ChatAction.vue?vue&type=template&id=1905c9a1&scoped=true"
import script from "./ChatAction.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatAction.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ChatAction.vue?vue&type=style&index=0&id=1905c9a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1905c9a1",
  null
  
)

export default component.exports